// src/pages/Auditorias/components/ProblemasLista.js
import React from 'react';
import { GRAVIDADE_CLASSE, GRAVIDADE_LABEL, formatarData } from '../utils/formatacao';

/**
 * Problemas agrupados por etapa processual, ordenados por gravidade dentro de
 * cada grupo (o backend já os entrega assim).
 *
 * O nome_original vem do campo "Nome" da DuraLex e repete-se muito — há dois
 * 'Not. da Sentença' e três 'Comunicação do SIATT' no mesmo processo. Sem a
 * data, o movimento e o nome real do PDF é impossível saber de qual se trata.
 */
const ProblemasLista = ({ problemas, onAbrirPeca, avaliarPecaIndividual = true }) => {
  if (!problemas) return <p className="aud-vazio">A carregar…</p>;

  // No modo parecer único esta secção fica sempre vazia — não porque não haja
  // problemas, mas porque as peças não foram conferidas uma a uma. Escrever
  // "nenhuma peça com reparos" seria afirmar que o processo está limpo.
  if (avaliarPecaIndividual === false) {
    return (
      <p className="aud-vazio">
        Esta auditoria correu em modo <strong>parecer único</strong>: o processo
        foi analisado por inteiro numa só leitura e os problemas não foram
        apurados peça a peça. Os achados estão no parecer final.
      </p>
    );
  }

  if (!problemas.total) {
    return <p className="aud-vazio">Nenhuma peça com reparos.</p>;
  }

  return (
    <>
      {problemas.grupos.map((grupo) => (
        <div key={grupo.etapa} className="aud-grupo">
          <div className="aud-grupo-titulo">{grupo.etapa}</div>

          {grupo.pecas.map((peca) => {
            const ficheiroReal = (peca.caminho_onedrive || '').split('/').pop();

            return (
              <button
                key={peca.id}
                type="button"
                className={`aud-problema ${GRAVIDADE_CLASSE[peca.gravidade] || ''}`}
                onClick={() => onAbrirPeca(peca)}
              >
                <div className="aud-problema-cabeca">
                  <span className={`aud-badge ${GRAVIDADE_CLASSE[peca.gravidade] || ''}`}>
                    {GRAVIDADE_LABEL[peca.gravidade] || peca.gravidade}
                  </span>
                  <span className="aud-problema-nome">{peca.nome_original}</span>
                  <span className="aud-problema-ordem">#{peca.ordem}</span>
                </div>

                <div className="aud-problema-ident">
                  {peca.data_movimento && <span>{formatarData(peca.data_movimento)}</span>}
                  {peca.acto && <span>{peca.acto}</span>}
                  {peca.interveniente && <span>{peca.interveniente}</span>}
                  {peca.movimento_referencia && (
                    <span className="aud-mono">mov. {peca.movimento_referencia}</span>
                  )}
                </div>

                {ficheiroReal && (
                  <div className="aud-problema-ficheiro" title={peca.caminho_onedrive}>
                    {ficheiroReal}
                  </div>
                )}

                <div className="aud-problema-resumo">{peca.resumo_linha}</div>

                {peca.nota_revisao && (
                  <div className="aud-problema-nota">
                    <strong>nota:</strong> {peca.nota_revisao}
                  </div>
                )}
              </button>
            );
          })}
        </div>
      ))}
    </>
  );
};

export default ProblemasLista;
